import { render } from "./Requests.vue?vue&type=template&id=58af1330"
import script from "./Requests.vue?vue&type=script&lang=js"
export * from "./Requests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Requests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58af1330"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58af1330', __exports__)) {
    api.reload('58af1330', __exports__)
  }
  
  module.hot.accept("./Requests.vue?vue&type=template&id=58af1330", () => {
    api.rerender('58af1330', render)
  })

}


export default __exports__